/**
 * @module Content Provider Hooks - Products
 * @description
 */
import { useEffect, useState, useContext } from 'react';
import { ContentProviderContext } from '../index';

/**
 * @function useContentProviderProduct
 * @description Fetch a product from Content Provider
 */
const useContentProviderProduct = ( hash ) => {
  const { isLoading, products } = useContext( ContentProviderContext );
  const [ featured, setFeatured ] = useState();

  /**
   * @function useEffect
   * @description Match our hash with a product
   */
  useEffect( () => {
    if ( isLoading === true || ! products ) {
      return;
    }

    const filteredProduct = products[ hash ];

    setFeatured( filteredProduct );
  }, [ hash, products, isLoading ] );

  return featured;
};

export default useContentProviderProduct;
